import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from 'store/resources';
import { getPusherAuthSettings } from 'services/auth';
import { IPusherConfig } from 'services/chats/types';

export const ThunkGetPusherAuthSettings = createAsyncThunk<IPusherConfig>(
  `${storeResources.AUTH}/getPusherAuthSettings`,
  () => getPusherAuthSettings().then(r => r.data),
);
